import { Component } from "react"

class ProfileImage extends Component{
    constructor(props){
        super(props)
        this.name = "プロフィール画像"
    }
    validate(callbackDialog,requireCheck){
        /*if(requireCheck && String(this.props).trim().length === 0){
            callbackDialog("エラー",this.name + "は必須です。")
            return false
        }*/
        return true
    }
}

export default ProfileImage;